import React from 'react'
import { defaultProps } from 'recompose'
import { Input } from 'reactstrap'
import { addNotification } from 'reapop'
import {
  CALL_API,
  COUNT_DETECTOR,
  createSelectorForEntityKey,
  createEntitiesSelector,
  createIdsSelector,
  getApiState,
} from '@infotech/lib-api-middleware'
import { DropdownList, Combobox, Spinner } from '@infotech/base-components'
import { createNotifyConf } from '@infotech/notify'
import { PrimaryButton, SecondaryButton } from '@infotech/uikit-button'

import ModalDialog from './ModalDialog'
import Pagination from './Pagination'

const Label = ({ children }) => (
  <div>
    { children }
  </div>
)

const dependencies = {
  referencePath          : `/reference-esz`,
  referenceDataChangePath: `/reference-data-change-request-service`,

  referenceDSInfos: {
    object: {type: 'ESZ', code: 'esz_object_equipment_widget'},
  },

  CALL_API,
  COUNT_DETECTOR,
  createSelectorForEntityKey,
  createEntitiesSelector,
  createIdsSelector,
  getApiState,

  Input,
  Label,
  DropdownList,
  Combobox: defaultProps({ filter: false })(Combobox),
  PrimaryButton,
  SecondaryButton,
  Spinner,

  ModalDialog,
  Pagination,

  errorNotificationAction  : (message) => addNotification(createNotifyConf(message, `error`)),
  successNotificationAction: (message) => addNotification(createNotifyConf(message, `success`)),

  simplified: true,
}

export default dependencies
